import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    FETCH_SEARCH_DATA: createAsyncActionConstants('FETCH_SEARCH_DATA'),
    RESET_SEARCH_DATA: createAsyncActionConstants('RESET_SEARCH_DATA')
}